<div class="upload-sign-recent-upload-container">
    @if(signService.isLoadingSignerSignatures) {
    <kzn-loader [message]="selfSignMode ? ('selfSignLoadingSaved' | translate) : 'Getting recent signs...'"></kzn-loader>
    } @else if (!signService.signerSignatures.length) {
    <p class="recent-uploads__empty">
      {{ selfSignMode ? ('selfSignNoSaved' | translate) : ('recentTab' | translate) }}
    </p>
    } @else {
    <mat-radio-group class="recent-uploads__container"
      [class.recent-uploads__container--self-sign]="selfSignMode"
      [formControl]="recentUploadImgCtrl"
      (change)="onImageSelected()">
        @for(signature of signService.signerSignatures; track signature.Id; let index = $index) {
        <mat-card class="mat-elevation-z8 recent-upload__container"
          [class.recent-upload__container--selected]="recentUploadImgCtrl.value?.Id === signature.Id"
          (click)="selectSignature(signature)">
            <mat-radio-button [value]="signature" color="primary">
                <img class="image-recent-upload" [src]="signature.SignImagePath" [alt]="signature.SignName || 'Signature'" />
            </mat-radio-button>
            @if (signature.SignName) {
              <span class="recent-upload__name">{{ signature.SignName }}</span>
            }
        </mat-card>
        }
    </mat-radio-group>
    }
</div>
